import {useState} from 'react';
import {affiche_param} from "../Fonctions"

export function DevoirResend ({auth, devoir, updateUsercontext, action}) {

 	// Dates
	const dat = new Date()
	const dat_month = dat.getMonth()+1 < 10 ? '0'+ (dat.getMonth()+1) : dat.getMonth()+1
	const dat_day = dat.getDate() < 10 ? '0'+ (dat.getDate()) : dat.getDate()
	const today = dat.getFullYear() + '-' + dat_month + '-' + dat_day
	const tomorow = dat.getFullYear() + '-' + dat_month + '-' + (dat_day+1)

 	const [classeToSend, setClasseToSend] = useState('')
 	const [dateDevoir, setDateDevoir] = useState({
 		active:'Non',
 		value:'0000-00-00'
 	})

	const style = {
	    color:'teal',
	    display:'block',
	    border:'3px solid lightcoral',
	    borderRadius:'5px',
	    padding:'5px',
	    margin:'10px 0px',
	    fontSize:'0.9em',
	  }

  	const handleChange = (e) => {
  		setDateDevoir({...dateDevoir, value:e.target.value})
	}

	const handleClick = (e) => {
		if(devoir.listeChoix){
		  fetch("https://maths-au-quotidien.fr/react-automaths/api-database.php", {
		      method: 'POST',
		      body: JSON.stringify({...auth, 
		      	action:'listeChoix', 
				nbEssaisMin:devoir.nbEssaisMin,
				save_serie_and_send:true,
				save_serie:false,
				niveau: devoir.niveau, 
				nb_question: devoir.nb_question, 
				etoile: ['0', '⭐', '⭐⭐', '⭐⭐⭐', '🅳'][devoir.etoile], 
				notions: devoir.activite, 
				classe: classeToSend,
				facultatif: devoir.facultatif === '0', 
				titre:devoir.title, 
				date_limit:dateDevoir.value, 
				consigne:devoir.consigne, 
				field:devoir.listeChoix, 
				replayable:devoir.replayable
			})
		    })
		    .then(response => response.json())
		    .then(data => {
		      console.log(data)
		      updateUsercontext()
		      action()
		    })
		    .catch(err => console.log(err))
		} else {
			fetch("https://maths-au-quotidien.fr/react-automaths/api-database.php", {
		      method: 'POST',
		      body: JSON.stringify({...auth, 
		      	action:'devoir_send', 
		      	field:[
					devoir.niveau,
					devoir.nb_question,
					['0', '⭐', '⭐⭐', '⭐⭐⭐', '🅳'][devoir.etoile],
					devoir.activite,
					classeToSend,
					devoir.facultatif === '0',
					devoir.title,
					dateDevoir.value,
					devoir.consigne,
				], 
				nbEssaisMin:devoir.nbEssaisMin,
			})
		    })
		    .then(response => response.json())
		    .then(data => {
		      //console.log(data)
		      updateUsercontext()
		      action()
		    })
		    .catch(err => console.log(err))
		}

	}

	//console.log('devoir : ', devoir)
	return (
		<div className="devoirResend" style={style}>
			<b>Envoyer ce devoir à une autre classe</b>
			<br/><br/>
			{
				affiche_param(auth.classes, classeToSend, 'classe', (e)=>setClasseToSend(e.target.innerText))
			}
			<br/>
			<span title={"La demande de faire le devoir ne sera pas supprimée automatiquement à cette date, le professeur garde la main pour le faire."}>Indiquer une date limite ?  {affiche_param(['Oui', 'Non'], dateDevoir.active, 'date_limit', ()=>dateDevoir.active === 'Oui' ? setDateDevoir({...dateDevoir, active:'Non', value:'0000-00-00'}) : setDateDevoir({...dateDevoir, active:'Oui', value:tomorow}))}</span>
           {dateDevoir.active === 'Oui' ? <input type="date" name="date_limit_value" value={dateDevoir.value} min={today} onChange={handleChange} /> : ''}

			{
				classeToSend && 
				<div align="center">
			    	<input className="btn standard" name="devoir_send" type="button" value="Envoyer" onClick={handleClick}/>
			    </div>
			}
		</div>
	);
}